import { SyntheticEvent } from "react";

export interface IGWidget {
    id?:string;
    className?:string;
}

export function combineClass(...classes:(Record<string,boolean>|string[]|string)[]){
    const flat:string[] = []
    for(const c of classes){
        if (c instanceof Array) flat.push(...c)
        else if (c instanceof Object){
            for(const key in c){
                if (c[key]) flat.push(key)
            }
        }
        else flat.push(c)
    }
    return flat.filter(c => !!c).join(" ")
}

export function appendClass(className:string, other:string[]|string|undefined) {
    if (!other) return className
    else if (other instanceof Array){
        let ret:string = className || ""
        for(const klass of other){
            if (klass) ret = (ret ? ret+" " : "") + klass
        }
        return ret
    }
    else return className ? className + " " + other : other;
}

export function addClass(className:string, props:IGWidget) {
    return appendClass(className, props.className)
}

export type TMouseEvent = (e:SyntheticEvent)=>void;
